<template>

   <div class="content_support" v-show="proofLoginStatus">

      <h2 style="margin-bottom:25px; font-size: 22px;margin-top: 0px;">{{ticket.title}}</h2>

      <div class="zusammenfassung">
         <strong>Ticket ID #{{ ticket.number }}</strong><br/>
         <strong>Erstellungsdatum: {{ ticket.created_at | formatDate }}</strong><br/>
         <strong>Erstellt von {{articles[0].from}}</strong> - {{articles[0].created_by}}<br/>
         <strong>Letzter Bearbeiter: {{ agent(ticket.owner_id) }}</strong><br/>
         <strong>
            <span v-if="ticket.state_id == '2'">
               Status: Offen
            </span>
            <span v-else-if="ticket.state_id == '1'">
               Status: Neu
            </span>
            <span v-else-if="ticket.state_id == '4'">
               Status: Geschlossen
            </span>
            <span v-else-if="ticket.state_id == '3'">
               Status: Warten auf Erinnerung
            </span>
            <span v-else-if="ticket.state_id == '7'">
               Status: Warten auf schließen
            </span>
            <span v-else>
               Status: N/A
            </span>
         </strong><br/>
         <strong>
            <span v-if="ticket.priority_id == '1'">
               Priorität: Niedrig
            </span>
            <span v-else-if="ticket.priority_id == '2'">
               Priorität: Mittel
            </span>
            <span v-else-if="ticket.priority_id == '3'">
               Priorität: Hoch
            </span>
            <span v-else>
               Priorität: N/A
            </span>
         </strong><br/>
         <strong>Kategorie: {{ articles[0].subject }}</strong>
      </div>

      <div style="margin-top:20px;">
         <div style="border-bottom:1px solid #ccc;padding-bottom:20px;">
            <p v-html="articles[0].body">{{articles[0].body}}</p>

            <div v-if="articles[0].attachments.length > 0" class="attachments_block">
               <span style="font-weight:bold">Anhänge</span>
               <ul class="attachments">
                  <li v-for="(att, $index1) of articles[0].attachments">
                     <a @click="showAttachment(articles[0].ticket_id, articles[0].id, att.id, att.preferences['Mime-Type'])"><i class="fas fa-file-download"></i> {{att.filename}}</a>
                  </li>
               </ul>
            </div>

         </div>         
      </div>

      <div>
         <ul class="articles_list">
            <li v-for="(item, $index) of loadedArticles" v-if="$index >= 1">
               <strong>Antwort von {{item.from}}</strong> - {{item.created_by}}<br/>
               erstellt am {{ item.created_at | formatDate }}<br/><br/>
               <p v-html="item.body">{{item.body}}</p>

               <div v-if="item.attachments.length > 0" class="attachments_block">
                  <span style="font-weight:bold">Anhänge</span>
                  <ul class="attachments">
                        <li v-for="(att, $index1) of item.attachments">
                           <a @click="showAttachment(item.ticket_id, item.id, att.id, att.preferences['Mime-Type'])"><i class="fas fa-file-download"></i> {{att.filename}}</a>
                        </li>
                  </ul>
               </div>

            </li>
         </ul>         
      </div>


      <div class="articleformular" style="margin-top:30px;" v-if="ticket.state_id == '2' || ticket.state_id == '1'">

         <div style="overflow:hidden;">
            <div style="float:left;width:60%;">
               <div class="inputfeld" style="height:250px;">
                  <label>Antwort schreiben</label>
                  <textarea v-model="newarticle.message" id="message" placeholder="Bitte geben Sie Ihre Nachricht an uns ein ..."></textarea>
                  <div class="errorm" v-if="error.message"><label class="error" for="message">Dieses Feld darf nicht leer sein.</label></div>
               </div>
            </div>

            <div style="float:left;width:40%">
               <div class="anhang" style="padding-left:25px;">
                  <label>Anhang 1</label>
                  <input @change="handleImage1" class="custom-input" type="file" style="border:none;padding:0px;" />
                  <div class="errorm" v-if="error.anhang1"><label class="error" for="message">Es dürfen nur Dateien hochgeladen werden, die 5 MB nicht überschreiten. Möglicherweise ist der Dateityp nicht erlaubt.</label></div>

                  <hr style="margin-top:10px;margin-bottom:15px;" />

                  <label>Anhang 2</label>
                  <input @change="handleImage2" class="custom-input" type="file" style="border:none;padding:0px;" />
                  <div class="errorm" v-if="error.anhang2"><label class="error" for="message">Es dürfen nur Dateien hochgeladen werden, die 5 MB nicht überschreiten. Möglicherweise ist der Dateityp nicht erlaubt.</label></div>
                  <!-- <img :src="image" /> -->
               </div>
            </div>
         </div>

         <ul class="buttons">
            <li>
               <router-link to="/" class="btn btn-primary grey" active-class="active_ticket" role="link">Abbrechen</router-link>
            </li>
            <li>
               <a href="#" class="btn btn-primary" @click="proofInput">Antwort abschicken</a>
            </li>
         </ul>

      </div>

      <div v-else>
         <ul class="buttons" style="margin-top:25px;">
            <li>
               <router-link to="/" class="btn btn-primary grey" active-class="active_ticket" role="link">Zurück</router-link>
            </li>
         </ul>         
      </div>


   </div><!-- content_dashboard -->

</template>

<script>
// import AppFilterSwitches from './AppFilterSwitches';
// import AppGetPosts from './AppGetPosts';

export default {

	data() {
		return {
         wpData, // global data made available via wp_localize_script.
         ticket: [],
         articles: [{
            from: "",
            created_by: "",
            subject: "",
            attachments: []
         }],
         newarticle: {
            message: "",
         },
         anhang1: {
            base64: "",
            name: "",
            type: ""
         },
         anhang2: {
            base64: "",
            name: "",
            type: ""
         },
         allowedFormats: ["image/png", "image/jpg", "image/jpeg", "application/pdf", "image/tiff", "application/rtf", "application/zip", "application/gzip", "application/msexcel", "text/plain", "message/rfc822", "application/vnd.ms-outlook", "application/msword"],

         created_at: "",

         error: {
            message: false,
            anhang1: false,
            anhang2: false   
         },
         summaryerror: false

		};
	},

   beforeMount() {
      if (this.$route.params.ticket_id) {

         var data = {
            'ticket_id': this.$route.params.ticket_id,
            'nonce': this.wpData.nonce,
            'restURL': this.wpData.rest_url,
            'zammad_token': this.$store.getters.getZammadToken
         }

         this.$store.dispatch('showTicket', data)
            .then(resp => {
               var ticket = [];
               var articles = [];
               if (resp.code != 200) {
                  console.log("Ticket konnte nicht geladen werden.")
               } else {
                  ticket = resp.ticket;
                  articles = resp.articles;
               }
               this.ticket = ticket;
               this.articles = articles;
               this.$store.commit('setStopLoadingWorkingScreen')
            })
            .catch(err => {
               this.$store.commit('setStopLoadingWorkingScreen')
               console.log(err)
            })  

      } else {
         this.$router.push('/');
      }
   },

   mounted() {

   },

   computed: {
      proofLoginStatus() {
         if (this.$store.getters.getZammadToken != "" && this.$store.getters.getZammadID != "" && this.$store.getters.isLoggedIn != "") {
            return true;
         } else {
            this.$router.push('/noAccess');
         }
      },
      loadedArticles() {
         return this.$store.getters.getLoadedArticles
      }
   },

	methods: {

      agent(id) {
         var agents = this.$store.getters.getAgents;
         var bearbeiter = "-"
         agents.forEach((element) => {
            if (element.id == id) {
               bearbeiter = element.name
            }
         });
         return bearbeiter
      },

      createNewArticle() {

         if (this.anhang1.base64 != "" || this.anhang2.base64 != "") {

            var attachments = []

            if (this.anhang1.base64 != "") {
               if (this.allowedFormats.includes(this.anhang1.type)) {
                  var anhang1 = {
                     "filename": this.anhang1.name,
                     "data": this.anhang1.base64,
                     "mime-type": this.anhang1.type
                  }
                  attachments.push(anhang1)
               }
            }

            if (this.anhang2.base64 != "") {
               if (this.allowedFormats.includes(this.anhang2.type)) {
                  var anhang2 = {
                     "filename": this.anhang2.name,
                     "data": this.anhang2.base64,
                     "mime-type": this.anhang2.type
                  }
                  attachments.push(anhang2)
               }
            }

            var data = {
               'ticket_id': this.$route.params.ticket_id,
               'subject': this.articles[0].subject,
               'body': this.newarticle.message,
               'content_type': "text/html",
               'type': 'note',
               'zammad_token': this.$store.getters.getZammadToken,
               'zammad_id': this.$store.getters.getZammadID,
               'restURL': this.wpData.rest_url,
               'nonce': this.wpData.nonce,
               'attachments': attachments //JSON.parse(attachments)
            }
            
         } else {
            var data = {
               'ticket_id': this.$route.params.ticket_id,
               'subject': this.articles[0].subject,
               'body': this.newarticle.message,
               'content_type': "text/html",
               'type': 'note',
               'zammad_token': this.$store.getters.getZammadToken,
               'zammad_id': this.$store.getters.getZammadID,
               'restURL': this.wpData.rest_url,
               'nonce': this.wpData.nonce
            }
         }

         this.$store.dispatch('createNewArticle', data)
            .then(resp => {
               if (resp.data.code == 201) {
                  this.newarticle.message = ""
                  this.anhang1.name = ""
                  this.anhang1.type = ""
                  this.anhang1.base64 = ""
                  this.anhang2.name = ""
                  this.anhang2.type = ""
                  this.anhang2.base64 = ""
                  //this.$router.push('/');
               } else {
                  console.log("Das Ticket konnte nicht angelegt werden.");
               }
            })
            .catch(err => {
               console.log(err)
            }) 

      },

      proofInput() {
         this.error.message = false;
         for (const [key, value] of Object.entries(this.newarticle)) {
            if (value == "" && key == "message") {
               this.error.message = true;
            }
         }
         this.summaryerror = false;
         for (const [key, value] of Object.entries(this.error)) {
            if (value === true) {
               this.summaryerror = true;
            }
         }
         if (!this.summaryerror) {
            this.createNewArticle();
         }
      },

      showAttachment(ticket_id, article_id, attachment_id, attachment_mimetype) {

         this.$store.commit('setLoadingWorkingScreen')

         var data = {
            'ticket_id': ticket_id,
            'article_id': article_id,
            'attachment_id': attachment_id,
            'attachment_mimetype': attachment_mimetype,
            'zammad_token': this.$store.getters.getZammadToken,
            'restURL': this.wpData.rest_url,
            'nonce': this.wpData.nonce
         }

         this.$store.dispatch('showAttachmentFromArticles', data)
            .then(resp => {
               if (resp.data.code == 200) {
                  const base64ImageData = resp.data.image;
                  const contentType = resp.data.mimetype;
                  const byteCharacters = atob(base64ImageData.substr(`data:${contentType};base64,`.length));
                  const byteArrays = [];
                  for (let offset = 0; offset < byteCharacters.length; offset += 1024) {
                      const slice = byteCharacters.slice(offset, offset + 1024);
                      const byteNumbers = new Array(slice.length);
                      for (let i = 0; i < slice.length; i++) {
                          byteNumbers[i] = slice.charCodeAt(i);
                      }
                      const byteArray = new Uint8Array(byteNumbers);
                      byteArrays.push(byteArray);
                  }
                  const blob = new Blob(byteArrays, {type: contentType});
                  const blobUrl = URL.createObjectURL(blob);
                  this.$store.commit('setStopLoadingWorkingScreen')
                  window.open(blobUrl, '_blank');
               }
            })
            .catch(err => {
               this.$store.commit('setStopLoadingWorkingScreen')
               console.log(err)
            }) 
      },

      handleImage1(e) {
         this.anhang1.name = ""
         this.anhang1.type = ""
         this.anhang1.base64 = ""
         this.error.anhang1 = false
         const selectedImage = e.target.files[0]; // get first file
         if (selectedImage) {
            console.log(selectedImage);
            if (this.allowedFormats.includes(selectedImage.type) && selectedImage.size <= 5000000) {
               this.anhang1.name = selectedImage.name
               this.anhang1.type = selectedImage.type
               this.createBase64Image1(selectedImage);
            } else {
               this.error.anhang1 = true
            }
         }
      },
      handleImage2(e) {
         this.anhang2.name = ""
         this.anhang2.type = ""
         this.anhang2.base64 = ""
         this.error.anhang2 = false
         const selectedImage = e.target.files[0]; // get first file
         if (selectedImage) {
            if (this.allowedFormats.includes(selectedImage.type) && selectedImage.size <= 5000000) {
               this.anhang2.name = selectedImage.name
               this.anhang2.type = selectedImage.type
               this.createBase64Image2(selectedImage);
            } else {
               this.error.anhang2 = true
            }
         }
      },
      createBase64Image1(fileObject) {
         const reader = new FileReader();
         reader.onload = (e) => {
            this.anhang1.base64 = e.target.result.split(',')[1];
         };
         reader.readAsDataURL(fileObject);
      },
      createBase64Image2(fileObject) {
         const reader = new FileReader();
         reader.onload = (e) => {
            this.anhang2.base64 = e.target.result.split(',')[1];
         };
         reader.readAsDataURL(fileObject);
      },

	}
};
</script>

<style scoped>

.articleformular ul.buttons li {
   display: inline-block;
   margin-right: 8px;
}

.articleformular .inputfeld {
   height: 85px;
}

.articleformular .col50_left {
    float: left;
    width: 47.5%;
    margin-right: 2.5%;
}

.articleformular .col50_right {
    float: left;
    width: 47.5%;
    margin-left: 2.5%;
}

.articleformular label, .articleformular input, .articleformular textarea, .articleformular select {
   display: block;
   font-family: 'Roboto', sans-serif;
}

.articleformular input:focus, .articleformular textarea:focus, .articleformular select:focus {
   border: 1px solid #272727;
   outline: none;
}

.articleformular input {
background-color: #ffffff;
  border: 1px solid #cccccc;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  -webkit-transition: border linear 0.2s, box-shadow linear 0.2s;
  -moz-transition: border linear 0.2s, box-shadow linear 0.2s;
  -o-transition: border linear 0.2s, box-shadow linear 0.2s;
  transition: border linear 0.2s, box-shadow linear 0.2s;
  line-height: 20px;
  padding: 7px;
  width: 100%;
  font-size: 15px;
  font-family: 'Roboto', sans-serif;
  color: #272727;
}

.articleformular textarea {
background-color: #ffffff;
  border: 1px solid #cccccc;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  -webkit-transition: border linear 0.2s, box-shadow linear 0.2s;
  -moz-transition: border linear 0.2s, box-shadow linear 0.2s;
  -o-transition: border linear 0.2s, box-shadow linear 0.2s;
  transition: border linear 0.2s, box-shadow linear 0.2s;
  line-height: 20px;
  padding: 7px;
  width: 100%;
  font-size: 15px;
  min-height: 200px;
  font-family: 'Roboto', sans-serif;
  color: #272727;
}

.articleformular select {
width: 100%;
  height: 36px;
  background-color: #ffffff;
  border: 1px solid #cccccc;
  color: #272727 !important;
  line-height: 36px !important;
  font-size: 15px;
  padding-left: 7px;
  font-family: 'Roboto', sans-serif;
}

ul.articles_list li {
   border-bottom:1px solid #ccc;
   padding-bottom:20px;
   padding-top:20px;
   padding-left: 20px;
   padding-right: 20px;
}

ul.articles_list li:nth-child(odd) {
   background-color: #f5f5f5;
}

.attachments_block {
   margin-top: 25px;
}

ul.attachments li {
   padding-top: 4px;
   padding-bottom: 4px;
   padding-left: 0px;
   padding-right: 0px;
}

ul.attachments li:first-child {
   padding-top: 2px;
}

ul.attachments li:last-child {
   border-bottom: 0px;
   padding-bottom: 0px;

}

ul.attachments li a {
   cursor: pointer;
   color: rgb(15, 35, 67);
}

</style>



// WEBPACK FOOTER //
// src/components/TicketSingleView.vue